import * as React from 'react';
import * as intl from 'react-intl-universal';
import { ChromeExtension } from '@lifesize/react-components';
import * as classes from './ChromeExtension.scss';

// props from Redux Store
export interface StateProps {
  isWaitingForExtensionInstall: boolean;
}

// props from Actions
export interface DispatchProps {
  onCancelClick: () => void;
  onInstallClick: () => void;
}

type Props = StateProps & DispatchProps;

const callToAction = () => {
  return (
    <div className={classes.callToActionContainer}>
      <span>
        {intl.get('extension_instructions_1')}
      </span>
      <span>
        {intl.get('extension_instructions_2', { buttonLabel: intl.get('button_add_extension') })}
      </span>
    </div>
  );
};

const ChromeExtensionComponent: React.FunctionComponent<Props> = props => {
  return (
    <div className={classes.chromeExtensionContainer}>
      <ChromeExtension
        callToActionText={callToAction()}
        cancelText={intl.get('button_skip_for_now')}
        isOkButtonDisabled={props.isWaitingForExtensionInstall}
        okDisabledText={intl.get('button_waiting_for_extension_install')}
        okText={intl.get('button_add_extension')}
        onCancelClick={props.onCancelClick}
        onOkClick={props.onInstallClick}
        skipText={intl.get('extension_skip_install_for_now')}
        titleText={intl.get('extension_required')}
      />
    </div>
  );
};

export default ChromeExtensionComponent;



// WEBPACK FOOTER //
// ./src/components/ChromeExtension.tsx